export class CompanySettings {
  company_invoice_terms_and_conditions?: string;
  company_invoice_footer?: string;
  domain!: string;
  uuid!: string;
  date_deleted?: number;
  date_created!: number;
  date_updated!: number;

  constructor(data: any) {
    this.company_invoice_terms_and_conditions = data.company_invoice_terms_and_conditions;
    this.company_invoice_footer = data.company_invoice_footer;
    this.domain = data.domain;
    this.uuid = data.uuid;
    this.date_deleted = data.date_deleted;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;
  }
}
